module.exports = __webpack_public_path__ + "static/img/manual-9.5c59104.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-9.png
// module id = 1ngo
// module chunks = 4